"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownSingleValue = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_select_1 = require("react-select");
var LoadingSpinner_1 = require("../../../Components/LoadingSpinner/LoadingSpinner");
var DropdownSingleValue = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownSingleValue, _super);
    function DropdownSingleValue(props) {
        var _this = _super.call(this, props) || this;
        _this.selectMinWidth = 220;
        _this.renderInput = function (props) {
            var InputComponent = react_select_1.components.Input;
            return (React.createElement(InputComponent, tslib_1.__assign({}, props, { autoComplete: "new-password", "aria-labelledby": props.id })));
        };
        _this.filterOption = function (option, input) {
            var label = option.label.toLowerCase();
            var searchValue = input.toLowerCase();
            return label.indexOf(searchValue) !== -1;
        };
        _this.onChangeHandler = function (selectedValue) {
            var _a;
            var _b = _this.props, filter = _b.filter, setIsResultsLoading = _b.setIsResultsLoading;
            var isNothingSelected = !_this.props.selectedValue;
            var dropdownLabel = filter.placeholder || filter.title;
            var isOptionAlreadySelected = ((_a = _this.state.selectedOption) === null || _a === void 0 ? void 0 : _a.label) === selectedValue.label;
            if ((isNothingSelected && dropdownLabel === selectedValue.label) || isOptionAlreadySelected) {
                return;
            }
            if (dropdownLabel === selectedValue.label) {
                _this.setState({ selectedOption: null });
            }
            else {
                _this.setState({ selectedOption: selectedValue });
            }
            _this.setState({ isLoading: true });
            setIsResultsLoading && setIsResultsLoading(true);
            _this.props.onFilterChange(_this.props.groupValue, selectedValue.value);
        };
        _this.renderDropdownIndicator = function (props) {
            return (React.createElement(react_select_1.components.DropdownIndicator, tslib_1.__assign({}, props),
                React.createElement("span", { className: "icon icon-chevron-down-small" }),
                React.createElement("span", { className: "icon icon-chevron-up-small" })));
        };
        _this.renderLoadingIndicator = function (props) {
            return (React.createElement(react_select_1.components.IndicatorsContainer, tslib_1.__assign({}, props),
                React.createElement(LoadingSpinner_1.default, { visible: true }),
                React.createElement("span", { className: "dropdown-single-loading-divider" })));
        };
        _this.getSelectedOptionFromValue = function (options, selectedValue) {
            return options.filter(function (option) { return option.value === selectedValue; })[0];
        };
        _this.selectSizeRef = React.createRef();
        _this.state = {
            selectWidth: null,
            isLoading: false,
            selectedOption: null,
        };
        return _this;
    }
    DropdownSingleValue.prototype.componentDidMount = function () {
        var _a = this.props, filter = _a.filter, selectedValue = _a.selectedValue, isHierarchyFilter = _a.isHierarchyFilter, isDocumentsZeroResults = _a.isDocumentsZeroResults;
        // We can't show selected hierarchy value as we don't receive details about all hierarchy
        // levels from API when zero results is shown on documents search.
        var hierarchyDisabledValue = '';
        var selectValue = isHierarchyFilter && isDocumentsZeroResults ? hierarchyDisabledValue : selectedValue;
        var selectedOption = this.getSelectedOptionFromValue(filter.items, selectValue);
        var selectWidth = this.getSelectWidth();
        this.setState({ selectWidth: selectWidth, isLoading: false, selectedOption: selectedOption });
    };
    DropdownSingleValue.prototype.componentDidUpdate = function (prevProps) {
        var setIsResultsLoading = this.props.setIsResultsLoading;
        var prevSelectedItem = prevProps.filter.items.find(function (item) { return item.selected; });
        var selectedItem = this.props.filter.items.find(function (item) { return item.selected; });
        if ((prevSelectedItem === null || prevSelectedItem === void 0 ? void 0 : prevSelectedItem.label) !== (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label)) {
            this.setState({ isLoading: false, selectedOption: selectedItem });
            setIsResultsLoading && setIsResultsLoading(false);
        }
    };
    DropdownSingleValue.prototype.render = function () {
        var _this = this;
        var _a = this.state, selectWidth = _a.selectWidth, isLoading = _a.isLoading, selectedOption = _a.selectedOption;
        var _b = this.props, filter = _b.filter, _c = _b.customDropdownClasses, customDropdownClasses = _c === void 0 ? '' : _c, selectedValue = _b.selectedValue, isDocumentsZeroResults = _b.isDocumentsZeroResults, _d = _b.onOpen, onOpen = _d === void 0 ? function () { return null; } : _d, _e = _b.onClose, onClose = _e === void 0 ? function () { return null; } : _e, groupValue = _b.groupValue;
        var isDisabled = isDocumentsZeroResults || filter.isDisabled || filter.items.length === 0;
        var dropdownLabel = filter.placeholder || filter.title;
        var unselectOption = {
            value: '',
            label: dropdownLabel,
        };
        var extendedOptions = tslib_1.__spreadArray([unselectOption], filter.items, true);
        var unselectOptionSelected = selectedValue === '';
        var customStyles = {
            control: function (provided) { return (tslib_1.__assign(tslib_1.__assign({}, provided), { width: _this.state.selectWidth })); },
        };
        var selectClassNames = "search-dropdown ".concat(unselectOptionSelected ? 'unselected' : '', " ").concat(selectedOption ? 'has-selected-value' : '', " ").concat(isLoading ? 'search-dropdown-is-loading' : '', " ").concat(customDropdownClasses);
        return (React.createElement("div", { className: "search-dropdown-wrapper", "data-filter-id": groupValue },
            selectWidth && (React.createElement(react_select_1.default, { backspaceRemovesValue: false, className: selectClassNames, classNamePrefix: "dropdown-single-value", components: {
                    DropdownIndicator: this.renderDropdownIndicator,
                    LoadingIndicator: this.renderLoadingIndicator,
                    IndicatorSeparator: function () { return null; },
                    Input: this.renderInput,
                }, isClearable: false, isDisabled: isDisabled || isLoading, isLoading: isLoading, isMulti: false, isSearchable: filter.isSearchable, filterOption: this.filterOption, onChange: this.onChangeHandler, onMenuClose: onClose, onMenuOpen: onOpen, options: extendedOptions, placeholder: dropdownLabel, styles: customStyles, value: selectedOption || '', tabSelectsValue: false, "aria-label": dropdownLabel })),
            React.createElement("div", { className: "select-size-detector", ref: this.selectSizeRef }, dropdownLabel)));
    };
    DropdownSingleValue.prototype.getSelectWidth = function () {
        var selectSizeDetectorWidth = this.selectSizeRef.current.offsetWidth;
        return selectSizeDetectorWidth > this.selectMinWidth
            ? selectSizeDetectorWidth
            : this.selectMinWidth;
    };
    return DropdownSingleValue;
}(React.Component));
exports.DropdownSingleValue = DropdownSingleValue;
